import { AppRouter } from "./appRouter";

const MainContainer = () => {
  return <AppRouter />;
};

export default MainContainer;
